export default "__VITE_ASSET__e22a0a0c__"